import React from "react";
import { SearchInputComponent } from "../../../common/components";
import { ServiceListSearchAndFiltersProps } from "./payment-billing-helper";
import { Stack, Badge, Box, Button } from "@mui/material";
import FilterIcon from "../../../assets/icons/filter-icon.svg";
import Filter from "./filter";
import "./payment-billing-search-filters.scss";

const ServiceListSearchAndFilters: React.FC<
  ServiceListSearchAndFiltersProps
> = ({
  onSearch,
  onFilterChange,
  onResetFilters,
  filterValues,
  placeholder = "Search by Customer Name, Order ID",
  appliedFiltersCount = 0,
  isFilterOpen = false,
  setIsFilterOpen,
  searchRef,
  isReset = false,
  localSearchText,
}) => {
  return (
    <>
      {/* Top search + actions */}
      <div className="search-and-filters-wrapper service-list-search-and-filters-wrapper">
        <div className="search-input-wrapper">
          <SearchInputComponent
            placeholder={placeholder}
            onSearch={onSearch}
            ref={searchRef}
            localSearchText={localSearchText}
          />
        </div>
        <div className="service-list-filter-icon-and-button-wrapper">
          {/* Filter badge */}
          <div
            className="service-list-icon-filter filter-icon-wrapper"
            onClick={() => setIsFilterOpen?.(true)}
            tabIndex={0}
          >
            <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
              <Badge
                color="secondary"
                badgeContent={appliedFiltersCount}
                invisible={appliedFiltersCount === 0}
              >
                <div className="icon-image-and-text">
                  <img src={FilterIcon} alt="Filter Icon" />
                  Filter
                </div>
              </Badge>
            </Stack>
          </div>
        </div>
      </div>
      <Filter
        open={isFilterOpen}
        onClose={() => setIsFilterOpen?.(false)}
        initialValues={filterValues}
        onApply={(filters) => {
          onFilterChange(filters);
        }}
        onReset={() => {
          onResetFilters?.();
        }}
      />
    </>
  );
};

export default ServiceListSearchAndFilters;
